import type { InterviewPracticeCampaignConfig } from './types'
import styles from './interview-practice-campaign.module.css'

/** Hero copy and media — shared by server pages and the client campaign shell (pathname-resolved config). */
export function CampaignHero({ config }: { config: InterviewPracticeCampaignConfig }) {
  const { hero, idPrefix } = config
  const heroId = `${idPrefix}-hero`
  const heroHeadingId = `${idPrefix}-hero-heading`

  return (
    <section id={heroId} className={styles.heroSection} aria-labelledby={heroHeadingId}>
      <div className={styles.heroIntro}>
        <span className={styles.roleBadge}>{hero.roleBadge}</span>
        <div className={styles.heroHeadlines}>
          <h1 id={heroHeadingId} className={styles.heroTitleLine}>
            {hero.titleLine}
          </h1>
          <p className={styles.heroTitleAccent}>{hero.titleAccent}</p>
        </div>
        {hero.subtitle ? <p className={styles.heroSubtitle}>{hero.subtitle}</p> : null}
      </div>

      {hero.heroImageSrc ? (
        <div className={styles.heroMediaBlock}>
          <div className={styles.heroImageWrap}>
            <img
              src={hero.heroImageSrc}
              alt={hero.heroImageAlt ?? ''}
              className={styles.heroImage}
            />
          </div>
          {hero.caption ? <p className={styles.heroCaption}>{hero.caption}</p> : null}
        </div>
      ) : hero.caption ? (
        <div className={styles.heroMediaBlock}>
          <p className={styles.heroCaption}>{hero.caption}</p>
        </div>
      ) : null}
    </section>
  )
}
